export const PINNED_MESSAGES_SCROLL_THRESHOLD_PX = 50;

/**
 * @param {HTMLElement | null | undefined} container
 * @returns {{ container: HTMLElement, pinned: boolean } | null}
 */
export function pinnedMessagesScroll(container = null) {
    const resolved =
        container ??
        document.querySelector(".prospus-messages-container__wrapper");

    if (!resolved) {
        return null;
    }

    const distance_from_bottom =
        resolved.scrollHeight -
        resolved.scrollTop -
        resolved.clientHeight;

    return {
        container: resolved,
        pinned: distance_from_bottom < PINNED_MESSAGES_SCROLL_THRESHOLD_PX,
    };
}

/**
 * @param {{ container: HTMLElement, pinned: boolean } | null | undefined} snapshot
 */
export function restorePinnedMessagesScroll(snapshot) {
    if (!snapshot?.pinned) {
        return;
    }

    snapshot.container.scrollTop = snapshot.container.scrollHeight;
}
